import { useSyncExternalStore } from 'react';
import type { DetailViewsQuota } from '@/api/types';

/**
 * Остаток дневной квоты детальных просмотров бесплатного тарифа — общий для
 * счётчика в углу и гейта открытия панели. Заполняется из `/me`, ответов
 * `POST /me/detail-views` и `GET /video-references/{id}`.
 */
let detailViews: DetailViewsQuota | null = null;
const listeners = new Set<() => void>();

export const quotaStore = {
  get: (): DetailViewsQuota | null => detailViews,
  set(next: DetailViewsQuota | null | undefined): void {
    if (next === undefined) return;
    detailViews = next;
    listeners.forEach((listener) => listener());
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

/**
 * Переход к нулю: остаток до списания был больше нуля, после — ноль. Пара «до/после»
 * берётся вокруг гейта открытия панели (`VideoDetailContext`), поэтому повторное
 * открытие при нуле (0 → 0), квота из `GET /video-references/{id}` и неизвестный
 * остаток до ответа `/me` (null) переходом не считаются.
 */
export function isLastFreeView(
  before: DetailViewsQuota | null,
  after: DetailViewsQuota | null,
): boolean {
  return before !== null && after !== null && before.remaining > 0 && after.remaining === 0;
}

export function useDetailViewsQuota(): DetailViewsQuota | null {
  return useSyncExternalStore(quotaStore.subscribe, quotaStore.get, quotaStore.get);
}
